import React from 'react';
import { Star } from 'lucide-react';
interface T {
  initials: string;
  name: string;
  role: string;
  country: string;
  text: string;
}
const Card = ({
  initials,
  name,
  role,
  country,
  text
}: T) => <div className="brunson-card rounded-lg p-4 md:p-5 flex flex-col h-full brunson-shadow" data-id="element-262">
    <div className="flex text-brand-orange mb-2" data-id="element-263">
      {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-264" />)}
    </div>
    <p className="text-sm md:text-base text-brand-ink italic leading-relaxed font-medium flex-grow" data-id="element-265">
      "{text}"
    </p>
    <div className="flex items-center gap-3 mt-3 pt-3 border-t border-brand-line" data-id="element-266">
      <div className="w-11 h-11 rounded-full bg-brand-orange text-white font-display font-bold flex items-center justify-center shrink-0" data-id="element-267">
        {initials}
      </div>
      <div data-id="element-268">
        <p className="font-display font-bold text-white text-sm uppercase leading-tight" data-id="element-269">
          {name}
        </p>
        <p className="text-xs text-brand-mute font-medium" data-id="element-270">
          {role} · {country}
        </p>
      </div>
    </div>
  </div>;
export function Testimonials() {
  const items: T[] = [{
    initials: 'RM',
    name: 'Ing. Roberto Méndez',
    role: 'Escuela Agrotécnica',
    country: 'Entre Ríos',
    text: 'Antes de Acuicultura Pro, pasaba mis vacaciones diseñando el curso. Ahora abro la Planificación del Bono 4, la ajusto en 20 minutos y listo. Mis alumnos aprenden más y yo duermo mejor.'
  }, {
    initials: 'LF',
    name: 'Profa. Lucía Fernández',
    role: 'Capacitadora Técnica',
    country: 'Chaco',
    text: 'El Tomo 5 de Sanidad les cambió la vida a mis alumnos. Por primera vez entienden por qué se mueren los peces y cómo prevenirlo. El protocolo de necropsia lo hicimos con una tilapia del mercado. Fue épico.'
  }, {
    initials: 'MP',
    name: 'Téc. Marcos Pereyra',
    role: 'Instructor de Campo',
    country: 'Neuquén',
    text: 'El material del Tomo 3 sobre trucha es el mejor que vi en 15 años trabajando en el sector. Habla exactamente de lo que viven los alumnos cada día en el campo.'
  }, {
    initials: 'SR',
    name: 'Profa. Sandra Romero',
    role: 'Escuela Agropecuaria',
    country: 'Santa Fe',
    text: 'Mis colegas me preguntan qué curso hice. Les digo que no fue un curso — fue un sistema. Y el sistema trabaja por vos.'
  }, {
    initials: 'DH',
    name: 'Prof. Diego Herrera',
    role: 'Instituto Técnico Agropecuario',
    country: 'Tucumán',
    text: 'Las rúbricas del Bono 2 me salvaron. Ya no discuto con los alumnos sobre las notas. Todo está explicado, criterio por criterio.'
  }];
  return <section className="py-9 px-4 bg-brand-creamAlt border-y border-brand-line" data-id="element-271">
      <div className="max-w-6xl mx-auto" data-id="element-272">
        <h2 className="text-2xl md:text-4xl font-display font-bold text-white text-center uppercase mb-6 leading-tight" data-id="element-273">
          Lo que dicen los <span className="orange-text" data-id="element-274">docentes:</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-275">
          {items.map((t, i) => <Card key={i} {...t} data-id="element-276" />)}
        </div>
      </div>
    </section>;
}